import { useEffect, useState } from 'react';
import apiService from 'services/BackendApi/BackendApi';

export function useDigitalArchivePage(props) {
    const { alias, stylesheet } = props;
    const [pageContent, setPageContent] = useState({
		isLoading: false,
		isError: false,
		payload: null,
		error: null,
	});

	useEffect(() => {
		setPageContent((prevPageContent) => ({
			...prevPageContent,
			isLoading: true,
		}));
		apiService
			.GetDigitalArchiveInfo({
				urlParams: {
					alias: alias,
					stylesheet: stylesheet,
				},
			})
			.then((response) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: false,
					payload: {
						metadata: response.data.metadatas,
                        document: response.data.document,
						breadC: response.data.breadC,
					},
				}));
			})
			.catch((error) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: true,
					error: error?.message,
				}));
			})
			.finally(() => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isLoading: false,
				}));
			});
	}, [alias]);

	return pageContent;
}